import { makeStyles, css } from '@conexasaude/conexa-hero'
import { UseStylesProps } from './types'

const useStyles = makeStyles<UseStylesProps>({
  root: theme => css`
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 10;
    padding: ${theme.spacing.xs} ${theme.spacing.sm};
    background-color: ${theme.colors.background.white};
    box-shadow: ${theme.shadow.level1};

    @media (max-width: ${theme.grid.breakpoint.sm}) {
      padding: ${theme.spacing.sm};
    }
  `,

  container: theme => css`
    max-width: ${theme.grid.breakpoint.xl};
    margin: 0 auto;
    padding: 0 ${theme.spacing.md};
  `,
})

export default useStyles
